"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _hotel = require("../../proptypes/hotel");
var _userflow = require("../../utils/userflow");
var _HotelOffersList = _interopRequireDefault(require("./HotelOffersList"));
var styles = {
  overlay: {
    background: 'rgba(145,148,153,.5)'
  },
  modal: {
    padding: 0,
    borderRadius: 4,
    marginTop: 70
  },
  closeButton: {
    zIndex: 9,
    top: 6,
    right: 10
  }
};
var HotelOffersModal = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var onClick = _ref.onClick,
    offers = _ref.offers,
    onClose = _ref.onClose,
    open = _ref.open;
  return /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal["default"], {
    open: open,
    center: true,
    styles: styles,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(StytledContent, null, /*#__PURE__*/_react["default"].createElement(StyledHeader, null, (0, _userflow.makeHeaderTitle)(offers)), /*#__PURE__*/_react["default"].createElement(OffersContainer, null, /*#__PURE__*/_react["default"].createElement(StyledHotelOffersList, {
    onClick: onClick,
    offers: offers
  }))));
});
HotelOffersModal.displayName = 'HotelOffersModal';
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersModal__StyledHeader",
  componentId: "sc-1x4twhw-0"
})(["position:absolute;top:0;width:100%;box-sizing:border-box;background:", ";z-index:5;font-weight:500;font-size:15px;padding:10px;border-top-left-radius:4px;border-top-right-radius:4px;color:", ";"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.blackBase;
});
var StytledContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersModal__StytledContent",
  componentId: "sc-1x4twhw-1"
})(["position:relative;background:", ";max-width:95vw;border:1px solid rgb(187,187,187);border-radius:4px;"], function (props) {
  return props.theme.colors.white;
});
var StyledHotelOffersList = (0, _styledComponents["default"])(_HotelOffersList["default"]).withConfig({
  displayName: "HotelOffersModal__StyledHotelOffersList",
  componentId: "sc-1x4twhw-2"
})(["position:relative;margin:0;box-shadow:none;::before{content:none;}"]);
var OffersContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersModal__OffersContainer",
  componentId: "sc-1x4twhw-3"
})(["padding-top:35px;max-height:100%;overflow-y:auto;min-width:290px;"]);
HotelOffersModal.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  offers: _propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired,
  onClose: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = HotelOffersModal;